import { graphql } from "react-relay";

export const UpdateUserMutation = graphql`
  mutation UpdateUserMutation($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        email
        key
        name
        roleAssignmentPrincipal
        roleAssignments(first: 100) {
          edges {
            node {
              id
              role {
                id
                name
                permissions
              }
              target {
                __typename
                roleAssignmentTarget
                ... on RoleScope {
                  displayName
                }
                ... on AccountGroup {
                  name
                }
                ... on PolicyCollection {
                  name
                }
                ... on RepositoryConfig {
                  name
                }
                ... on Node {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;
